import { PercentageValue } from "../percentage_value";
import { ShortlistWithScores } from "../types";

type MatchCellProps = {
  shortlist: ShortlistWithScores;
};

export const MatchCell = ({ shortlist }: MatchCellProps) => (
  <PercentageValue value={shortlist.scores?.normalizedScore ?? null} />
);
